import { BoardApi } from "../../../services/board-service-api";
import { BoardView } from "./types";

// Saved views are now backend-backed (per user, scoped to the workspace) instead of
// localStorage, so they follow the user across devices. This is a thin cache over
// the REST endpoints: list() reads the cache, refresh() fetches it, create/remove
// mutate via the API then update the cache and notify subscribers.

export type SavedView = BoardView;

type Listener = (views: SavedView[]) => void;
const listeners: Set<Listener> = new Set();
let cache: SavedView[] = [];

function emit(): void {
  for (const listener of listeners) listener(cache);
}

export const SavedViews = {
  list(): SavedView[] {
    return cache;
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  async refresh(): Promise<void> {
    try {
      cache = await BoardApi.getViews();
      emit();
    } catch {
      // exceptionHandler already surfaced the error.
    }
  },

  async create(name: string, href: string): Promise<SavedView | null> {
    try {
      const view: SavedView = await BoardApi.createView(name, href);
      cache = [...cache, view];
      emit();
      return view;
    } catch {
      return null;
    }
  },

  async remove(id: string): Promise<void> {
    try {
      await BoardApi.removeView(id);
      cache = cache.filter((view: SavedView) => view.id !== id);
      emit();
    } catch {
      // exceptionHandler already surfaced the error.
    }
  }
};
